import { getSafeData } from '../utils';
import { getByID } from './getByID';
import { getDuplicates } from './getDuplicates';
import { getList } from './getList';
import { getListForTopic } from './getListForTopic';
import { getQuestionTopicList } from './getQuestionTopicList';
import { search } from './search';
// Re-export utility functions
export { applySorting, getQuestionPaperData, isDuplicateQuestion as isDuplicate } from './utils';
// Combine all APIs into a single object
const QuestionAPIs = {
    // Basic operations
    getList,
    getByID,
    // Topic operations
    getListForTopic,
    getQuestionTopicList,
    // Search operations
    search,
    // Duplicate operations
    getDuplicates,
    // Utility function
    getSafeData,
};
export default QuestionAPIs;
